import React from "react";
import { FormSelectField } from "@components-shared/desktop/inputs";
import { LanguageDataType } from "@data-types/membership/registration";

export default function NameInput(props: {
	languageData: LanguageDataType[] | null;
	labelClassName?: string;
}) {
	const { languageData, labelClassName } = props;

	const mapLanguagesForFormSelect = (
		defaultLangs: LanguageDataType[] | null
	) => {
		if (!defaultLangs) {
			return;
		}

		return defaultLangs.map((lang) => {
			return {
				id: lang.culture,
				name: lang.name,
			};
		});
	};

	return (
		<FormSelectField
			label="registration:CONTACT_LANGUAGE"
			labelClassName={labelClassName}
			id="languageId"
			name="languageId"
			dropdownData={mapLanguagesForFormSelect(languageData)}
			className="form__field"
			required
		/>
	);
}
